var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.destinations,"label":_vm.$t('productsImport.selectDestination'),"rules":[function (v) { return !!v || _vm.$t('productsImport.selectDestination'); }],"item-text":function (v) { return v.getName(); },"item-value":_vm.selectedDestination ? _vm.selectedDestination.getSlug() : null,"return-object":"","outlined":""},on:{"change":function (v) {
      this$1.$emit('update:selectedDestination', v)
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }